import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';

import css from './BooksCreateUserAlert.module.scss';

interface Props {
  className?: string;
  onClick: () => void;
}

const BooksCreateUserAlert = ({
  className,
  intl,
  onClick,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksCreateUserAlert, className);

  return (
    <div className={classes}>
      <p className={css.BooksCreateUserAlert__Paragraph}>
        {intl.formatMessage({ id: 'books.forms.createUserAlertMessage1' })}
      </p>
      <p className={css.BooksCreateUserAlert__Paragraph}>
        <FormattedMessage
          id="books.forms.createUserAlertMessage2"
          values={{
            login: (
              <a onClick={onClick} className={css.BooksCreateUserAlert__Link}>
                {intl.formatMessage({ id: 'books.forms.here' })}
              </a>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default injectIntl(BooksCreateUserAlert);
